import { UPDATE_COLLABRATOR_LIST, UPDATE_SELECTED_COLLABRATOR, USER_AUTHENTICATED_LOGIN } from "../reducers/keys";
import { TOAST_ERROR, decrypt, encrypt } from "../utils";
import { getWallFeeds } from "./analyticsAction";
import { CHECK_COLLABRATOR_EXIST, REJECT_COLLABRATOR_REQUEST, SET_COLLABRATOR_PASS } from "./api";
import HttpClient from "./http-client";
import { getIPDetails, getUserInfo, getUseronboardingInfo } from "./loginActions";


export function updateCollabratorList(collabratorList) {
    return { type: UPDATE_COLLABRATOR_LIST, payload: collabratorList };
}

export function updateSelectedCollabratorToken(collabratorDetails) { 

    localStorage.setItem('access_token', collabratorDetails.collabratorAccessToken);
    localStorage.setItem('ownerId', collabratorDetails.userId);

    return (dispatch) => { 
        const decryptData = decrypt(localStorage.getItem("user_data"));
        const userDetails = JSON.parse(decryptData);
        const loginOwnerId = localStorage.getItem('loginOwnerId');

        userDetails['UserRule'] = collabratorDetails['UserRule'];
        userDetails['UserPlan'] = collabratorDetails['UserPlan'];
       
        dispatch(getWallFeeds(collabratorDetails.userId, loginOwnerId == collabratorDetails.userId ? 0: 1));
        dispatch({ type: UPDATE_SELECTED_COLLABRATOR, payload: collabratorDetails });
        dispatch({ type: USER_AUTHENTICATED_LOGIN, payload: { ...userDetails } });

        const encryptedData = encrypt(JSON.stringify(userDetails));
        localStorage.setItem('user_data', encryptedData);
    }
}

export function updateCollabratorPass(pass, ownerId, wallId, callBack, history) { 
    return async (dispatch) => {
        let data = {};
        await getIPDetails().then((ipResponse) => {
            data = ipResponse.data;
        }).catch(ex => console.log(ex));

        await new HttpClient().post(`${SET_COLLABRATOR_PASS}`, {
            userId: ownerId,
            wallId: wallId,
            password: pass,
            countryCode: (data && Object.keys(data).length > 0) ? data.country : "US"
        }).then((response) => {
            const { responseData } = response.data;
            if (responseData && Object.keys(responseData).length > 0) {
                if (responseData.token) {
                    localStorage.setItem('access_token', responseData.token);
                    const { user } = responseData;


                    if (user && Object.keys(user).length > 0) {
                        localStorage.setItem('ownerId', user.ownerId)
                        // localStorage.setItem('loginOwnerId', user.id);
                        localStorage.setItem('loginOwnerId', user.userhashId)
                        localStorage.setItem('isCollaborator', 0);
                    }
                    callBack();
                    

                    dispatch(getUseronboardingInfo(()=> history(`/walls`), false, null));
                }
            }
        }).catch(ex => {
            const response = ex.response;
            if (response && response.data && Object.keys(response.data).length > 0) {
                TOAST_ERROR(response.data.message)
            }
        });
    }
}

export function rejectCollabratorRequest(ownerId, wallId) {
    return new HttpClient().delete(`${REJECT_COLLABRATOR_REQUEST}/${ownerId}/${wallId}`);
}

export const checkIfCollabratorExist = async (ownerId, wallId) => {
    let data = {};
    await getIPDetails().then((ipResponse) => {
        data = ipResponse.data;
    }).catch(ex => console.log(ex));

    return new HttpClient().post(`${CHECK_COLLABRATOR_EXIST}`, {
        userId: ownerId,
        wallId: wallId,
        password: '',
        countryCode: (data && Object.keys(data).length > 0) ? data.country : "US"
    });
}